import {
  CAR_RENTAL_FILTERS_CHANGE,
  CAR_RENTAL_FILTERS_RESET,
  CAR_RENTAL_FILTERS_UPDATE,
  CAR_RENTAL_SEARCH_FORM_CHANGE,
  CAR_RENTAL_SEARCH_FORM_RESET,
  CAR_RENTAL_SEARCH_FORM_UPDATE,
  CAR_RENTAL_SEARCH_RESULTS_CHANGE,
  CAR_RENTAL_SEARCH_RESULTS_IDLE,
  CAR_RENTAL_SEARCH_RESULTS_LOADING,
  CAR_RENTAL_SEARCH_RESULTS_RESET,
  CAR_RENTAL_SEARCH_RESULTS_UPDATE,
  CAR_RENTAL_SINGLE_FILTER_RESET,
  SELECTED_CAR_RENTAL_CHANGE,
  SELECTED_CAR_RENTAL_IDLE,
  SELECTED_CAR_RENTAL_LOADING,
  SELECTED_CAR_RENTAL_RESET,
  SELECTED_CAR_RENTAL_UPDATE,
} from "./types";

// ================= CAR RENTAL SEARCH FORM ======================
export const carRentalSearchFormUpdate = ({ form }) => {
  return { type: CAR_RENTAL_SEARCH_FORM_UPDATE, form };
};

export const carRentalSearchFormChange = (key, value) => {
  return { type: CAR_RENTAL_SEARCH_FORM_CHANGE, key, value };
};

export const carRentalSearchFormReset = () => {
  return { type: CAR_RENTAL_SEARCH_FORM_RESET };
};

// ================ CAR RENTAL SEARCH RESULTS ====================
export const carRentalSearchResultsLoading = () => {
  return { type: CAR_RENTAL_SEARCH_RESULTS_LOADING };
};

export const carRentalSearchResultsIdle = () => {
  return { type: CAR_RENTAL_SEARCH_RESULTS_IDLE };
};

export const carRentalSearchResultsChange = (key, value) => {
  return { type: CAR_RENTAL_SEARCH_RESULTS_CHANGE, key, value };
};

export const carRentalSearchResultsUpdate = (results) => {
  return { type: CAR_RENTAL_SEARCH_RESULTS_UPDATE, results };
};

export const carRentalSearchResultsReset = () => {
  return { type: CAR_RENTAL_SEARCH_RESULTS_RESET };
};

export const carRentalSearchResultsFailed = () => {
  return { type: CAR_RENTAL_SEARCH_RESULTS_CHANGE, key: "failed", value: true };
};

// ============== CAR RENTAL FILTER RESULTS ======================
export const carRentalFiltersReset = () => {
  return { type: CAR_RENTAL_FILTERS_RESET };
};

export const carRentalSingleFiltersReset = (key) => {
  return { type: CAR_RENTAL_SINGLE_FILTER_RESET, key };
};

export const carRentalFiltersChange = (key, value) => {
  return { type: CAR_RENTAL_FILTERS_CHANGE, key, value };
};

export const carRentalFiltersUpdate = (filters) => {
  return { type: CAR_RENTAL_FILTERS_UPDATE, filters };
};

// =================== SELECTED TRANSFER =========================
export const selectedCarRentalReset = () => {
  return { type: SELECTED_CAR_RENTAL_RESET };
};

export const selectedCarRentalLoading = () => {
  return { type: SELECTED_CAR_RENTAL_LOADING };
};

export const selectedCarRentalIdle = () => {
  return { type: SELECTED_CAR_RENTAL_IDLE };
};

export const selectedCarRentalChange = ({ key, value }) => {
  return { type: SELECTED_CAR_RENTAL_CHANGE, key, value };
};

export const selectedCarRentalUpdate = (data) => {
  return { type: SELECTED_CAR_RENTAL_UPDATE, data };
};
